import * as S from "../../Style/Page/Social.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleSocial.js";
import HatPageTopLine from "../../Component/SocialPageTopLine.js";
import MainImg from "../../assets/socail/08. 연암장학회.png";
const Scholarship = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"사회사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/SocialService">
                <div className="kor">사회사업</div>
                <div className="eng">Social Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/SocialBusiness/Scholarship">
                <div className="kor">연암장학회</div>
                <div className="eng">Yeonam Scholarship Foundation</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">복지사업</div>
                  <div className="eng">Welfare Services</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Scholarship">
                  <div className="kor">연암장학회</div>
                  <div className="eng">Yeonam Scholarship Foundation</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/EducationBusiness">
                  <div className="kor">교육사업</div>
                  <div className="eng">YoungAn Education Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Obs">OBS</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/Museum">
                  <div className="kor">영안역사관</div>
                  <div className="eng">YoungAn History Museum</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"연암장학회"}
              titleeng={"Yeonam Scholarship Foundation"}
              link={"http://www.yeonam.or.kr/"}
            />
            <img src={MainImg} alt="" className="fullsize-map" />
            <div className="page-text">
              <div className="kor">
                재단법인 연암장학회는 1976년 설립되어 공익법인의 설립 운영에
                관한 법률규정에 따라, 국가와 사회 발전에 공헌할 수 있는 우수한
                학생과 극빈자에 대해 장학금을 지급하고 교육기관을 지원하는 등
                장학 사업을 전개하고 있습니다. 연암장학회는 매년 2회씩
                정기적으로 장학금을 지급하고 있으며, 1976년부터 2023년 현재까지
                총 6,500여 명의 고등학생과 대학생이 약 58억 원의 장학금을
                수여받았습니다.
              </div>
              <div className="eng">
                Yeonam Scholarship Foundation, established in 1976 in accordance
                with the regulations on the establishment and operation of
                public interest corporations, operates various scholarship
                programs, such as providing scholarships to outstanding students
                who can contribute to the development of the nation and society,
                as well as those in extreme financial need, along with
                supporting educational institutions and more. Yeonam Scholarship
                Foundation regularly grants scholarships twice a year, and from
                1976 to 2023, a total of approximately 5.8 billion won in
                scholarships has been awarded to over 6,500 high school and
                university students.
              </div>
            </div>
            <PageTitle
              titleko={"재단 주요사업이력"}
              titleeng={"Foundation History"}
            />
            <div className="page-text">
              <div className="kor">
                <span className="date">1976. 6. 24.</span> 재단법인 남영장학회
                설립 (설립자: 남상수 명예회장)
                <br />
                <span className="date">1976. 8. 6.</span> 문화교육부 설립 인가 /
                김재식 초대이사장 취임
                <br />
                <span className="date">1979. 12. 31.</span> 학생 304명에게
                3,200만 원의 장학금 지급 (1976년~1979년)
                <br />
                <span className="date">1989. 12. 31.</span> 학생 1,570여 명에게
                3억 9천만 원의 장학금 지급 (1980년~1989년)
                <br />
                <span className="date">1999. 12. 31.</span> 학생 1,630여 명에게
                9억 2천만 원의 장학금 지급(1990년~1999년)
                <br />
                <span className="date">2007. 2. 6</span> 재단법인 연암장학회로
                재단명 변경 / 설립자의 호 “연암”을 재단명으로 변경
                <br />
                <span className="date">2009. 12. 31.</span> 학생 1,440여 명에게
                20억 원의 장학금 지급 (2000년~2009년)
                <br />
                <span className="date">2013. 8. 29.</span> 기획재정부로부터
                성실공익법인 선정
                <br />
                <span className="date">2015. 2. 9.</span> 남석우 이사장 취임
                <br />
                <span className="date">2019. 12. 31.</span> 학생 2,000여 명에게
                총 24억 원의 장학금 지급 (2010년~2019년)
                <br />
                <span className="date">2022. 12. 27.</span> 백정수 이사장 취임{" "}
                <br />
                <span className="date">~ 2023년</span> 학생 6,500여 명에게 총
                58억 원의 장학금 지급(누적) <br />
              </div>
              <div className="eng">
                <span className="date">1976. 6. 24.</span> Namyoung Scholarship
                Foundation established (Founder: Honorary Chairman Nam Sang-soo)
                <br />
                <span className="date">1976. 8. 6.</span> Approved by the
                Ministry of Culture and Education / Kim Jae-sik inaugurated as
                the first chairman of the board
                <br />
                <span className="date">1979. 12. 31.</span> 32 million won in
                scholarships awarded to 304 students (1976-1979)
                <br />
                <span className="date">1989. 12. 31.</span> 390 million won in
                scholarships awarded to 1,570 students (1980-1989)
                <br />
                <span className="date">1999. 12. 31.</span> 920 million won in
                scholarships awarded to 1,630 students (1990-1999)
                <br />
                <span className="date">2007. 2. 6</span> Foundation name changed
                to Yeonam Scholarship Foundation for the memory of founder's pen
                name, "Yeonam"
                <br />
                <span className="date">2009. 12. 31.</span> 2 billion won in
                scholarships awarded to 1,440 students (2000-2009)
                <br />
                <span className="date">2013. 8. 29.</span> Selected as a sincere
                public benefit corporation by the Ministry of Economy and
                Finance
                <br />
                <span className="date">2015. 2. 9.</span> Nam Seok-woo
                inaugurated as chairman of the board
                <br />
                <span className="date">2019. 12. 31.</span> 2.4 billion won in
                scholarships awarded to 2,000 students (2010-2019)
                <br />
                <span className="date">2022. 12. 27.</span> Baik Jung-soo
                inaugurated as chairman of the board <br />
                <span className="date">~ 2023년</span> a total of 5.8 billion
                won in scholarships has been awarded to over 6,500 students
                (accumulated) <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Scholarship;
